<template>
    <div class="max-w-lg md:ml-12"> 
        <div role="status" class="my-7 animate-pulse"> 
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[500px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[450px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[380px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px]"></div>
            <span class="sr-only">Loading...</span> 
        </div>
        <div role="status" class="my-6 animate-pulse"> 
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[450px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[500px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[450px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[380px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px]"></div>
            <span class="sr-only">Loading...</span> 
        </div>
        <div role="status" class="my-6 animate-pulse"> 
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[450px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[500px] mb-4"></div>
            <span class="sr-only">Loading...</span> 
        </div>
        <div role="status" class="mb-6 mt-7 animate-pulse">

            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[450px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[500px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[450px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[380px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[500px] mb-4"></div>
            <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px]"></div>
            <span class="sr-only">Loading...</span> </div>
            <div role="status" class="my-6 animate-pulse">
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[460px] mb-4"></div>
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-900 max-w-[450px] mb-4"></div>
            <span class="sr-only">Loading...</span> 
        </div>
    </div>
</template>